export default __webpack_public_path__ + "static/media/icon-local.43030f86.svg";